import "./InfoSection.css";
import img1 from "../../assets/image/1.webp";
import img2 from "../../assets/image/2.webp";
import img3 from "../../assets/image/3.webp";
import img4 from "../../assets/image/4.webp";

export default function InfoSection() {
  return (
    <section className="info-section">
      <div className="container">
        <h2 className="text-center mb-4">Feature Solutions</h2>

        <div className="info-grid">
          <div className="info-item">
            <img src={img1} alt="PicOS" />
            <h6>PicOS Switch Software</h6>
            <p>
              Disaggregated NOS built on industry-standard Debian Linux seamlessly
              integrates into any network environment.
            </p>
          </div>

          <div className="info-item">
            <img src={img2} alt="AmpCon" />
            <h6>AmpCon Management Platform</h6>
            <p>
              Deploy, orchestrate, and manage data center and campus networks at
              scale with automated workflows.
            </p>
          </div>

          <div className="info-item">
            <img src={img3} alt="PicOS-V" />
            <h6>PicOS-V Virtual Operating System</h6>
            <p>
              Prototype network ops, validate configuration, and test features
              with PicOS-V.
            </p>
          </div>

          <div className="info-item">
            <img src={img4} alt="Customized" />
            <h6>Software Customized</h6>
            <p>
              Further software customization and enhancements to meet your exact
              requirements.
            </p>
          </div>
        </div>
      </div>
    </section>
    
  );
}
